<template>
    <GlassOptionForm :glass_option="glass_option" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import GlassOptionForm from './GlassOptionForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    GlassOptionForm
  },
  data() {
    return {
      glass_option:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.glass_option=await APIRequest.detail('glass-options',this.$route.params.id)
    this.loaded=true
    
  }
}
</script>
